export default __webpack_public_path__ + "static/media/bottom_icon.7d21828f.png";